/* eslint-disable no-console */
import { onError as onErrorApollo } from '@apollo/client/link/error'
import { GraphQLError } from 'graphql'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import {
  handleExtensionError,
  reportGraphQLError,
  reportNetworkError,
} from './errorHandlers'
import { ErrorCallback, ErrorExtensions } from './errorHandlers/types'
import codeByMessage from './utils/codeByMessage'

/**
 * Main Apollo error handler that orchestrates different error types
 * @param errorCallback - Callback function for error handling
 * @param router - Optional Next.js app router instance
 * @returns Apollo error link
 */
const onError = (errorCallback: ErrorCallback, router?: AppRouterInstance) =>
  onErrorApollo(({ graphQLErrors, networkError, operation, forward }) => {
    console.log('👹 ~ Error: APOLLO_ERROR_NAME', operation.operationName)
    console.log(
      '👹 ~ Error: APOLLO_ERROR_VARIABLES',
      JSON.stringify(operation.variables)
    )

    // Handle GraphQL errors
    if (graphQLErrors) {
      graphQLErrors.forEach((err: GraphQLError) => {
        reportGraphQLError(
          err as GraphQLError & { extensions: ErrorExtensions }
        )
        handleExtensionError({
          code: codeByMessage(err) || err.extensions.code,
          callback: errorCallback,
          router: router,
        })
      })
      forward(operation)
    }

    // Handle network errors
    if (networkError) {
      reportNetworkError(networkError)
    }
  })

export default onError
